import { Profile, StringMap, GetProfilesOutput, RequestContext, queryParameterValue, safeBool } from 'DVWebNodeUtils'

export interface ProfilesProps {
    isCerberusEnabled: boolean,
    data: GetProfilesOutput
  }
  
export interface NavProfiles {
    strings: StringMap,
    links: StringMap,
    activeProfile?: Profile,
    otherProfiles: Profile[],
    tooltipType: 'INTRO' | 'ERROR' | 'SWITCH_FAIL' | null,
    message?: String,
    canCreate: Boolean
}

export const transformProfiles = (cerberusProps: ProfilesProps, context: RequestContext) => {
    const cerberusData = cerberusProps.isCerberusEnabled && cerberusProps.data
    const hasActiveProfile = cerberusData && cerberusData.profiles.some(_ => _.isSelected)

    const errorMessage = cerberusData && cerberusData.message
    const hasIntroTooltip = cerberusData && cerberusData.showIntro
    const hasSwitchFailTooltip = queryParameterValue(context, 'switchSuccess') === '0'
    const tooltipType = hasIntroTooltip ? 'INTRO' as 'INTRO' : 
        errorMessage ? 'ERROR' as 'ERROR' :
        hasSwitchFailTooltip ? 'SWITCH_FAIL' as 'SWITCH_FAIL' : null
    
    if (cerberusData) {
        return {
            strings: cerberusData.strings,
            links: cerberusData.links,
            activeProfile: hasActiveProfile && cerberusData.profiles.find(_ => _.isSelected),
            otherProfiles: cerberusData.profiles.filter(_ => !_.isSelected),
            tooltipType: tooltipType,
            message: errorMessage,
            canCreate: safeBool(cerberusData.canCreate)
        }
    }
    return null
}
